import { i18nMark } from 'lingui-react';

const messages = {
  breakdown: i18nMark('Breakdown'),
  maintenance: i18nMark('Maintenance'),
  title: i18nMark('What type of Service?'),
  requestType: i18nMark('Request Type'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/WizardSteps/ServiceRequestType/messages.js